import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { unitResource } from './../underwritingManage/request';
import { agencyTree, agencyList, delAgency, agencyLevelList, agencyStatus } from './request';
import standardTable from '@/components/standardTable/index';
export default {
  components: {
    standardTable
  },
  data() {
    return {
      level: '-1',
      tableData: [],
      unitList: [],
      data: [],
      form: {
        unitId: '',
        agencyId: '',
        name: '',
        status: undefined
      },
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      filterText: '',
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      loading: false,
      tableHead: [{
        slots: {
          title: '序号'
        },
        dataIndex: 'index',
        scopedSlots: {
          customRender: 'index'
        },
        width: 80,
        align: 'center'
      }, {
        slots: {
          title: '机构全称'
        },
        dataIndex: 'name',
        align: 'center'
      }, {
        slots: {
          title: '机构级别'
        },
        dataIndex: 'level',
        align: 'center',
        scopedSlots: {
          customRender: 'level'
        }
      }, {
        slots: {
          title: '机构状态'
        },
        dataIndex: 'status',
        scopedSlots: {
          customRender: 'status'
        },
        align: 'center'
      }, {
        slots: {
          title: '更新时间'
        },
        dataIndex: 'updateAt',
        align: 'center'
      }, {
        slots: {
          title: '操作'
        },
        scopedSlots: {
          customRender: 'action'
        },
        align: 'center',
        width: 150
      }],
      agencyLevelList: agencyLevelList
    };
  },
  watch: {
    filterText(val) {
      console.log(val);
      this.$refs.tree.filter(val);
    }
  },
  created() {
    unitResource({}).then(res => {
      this.unitList = res;
      if (localStorage.getItem('homeUnitId')) {
        let arr = res.filter(item => item.id == localStorage.getItem('homeUnitId'));
        console.log(arr);
        if (arr.length != 0) {
          this.form.unitId = arr[0].id;
          localStorage.setItem('homeUnitId', arr[0].id);
        } else {
          this.form.unitId = res[0].id;
          localStorage.setItem('homeUnitId', res[0].id);
        }
      } else {
        this.form.unitId = res[0].id;
        localStorage.setItem('homeUnitId', res[0].id);
      }
      this.getTreeFun();
      this.getTableFun();
    });
  },
  methods: {
    filterOption(input, option) {
      return option.componentOptions.children[0].componentOptions.propsData.title.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    getTreeFun() {
      agencyTree({
        unitId: this.form.unitId
      }).then(res => {
        console.log(res, 555);
        this.data = res;
        this.$nextTick(() => {
          // 默认高亮选中节点
          this.$refs.tree.setCurrentKey(this.data[0].id);
        });
      });
    },
    getTableFun() {
      let obj = this.form;
      obj.page = this.pagination.current;
      obj.pageSize = this.pagination.pageSize;
      agencyList(obj).then(res => {
        console.log(res, 9999);
        this.pagination.total = res.totalNum;
        this.tableData = res.items;
      });
    },
    unitFun() {
      this.pagination.current = 1;
      this.form.agencyId = '';
      localStorage.setItem('homeUnitId', this.form.unitId);
      this.getTreeFun();
      this.getTableFun();
    },
    handleNodeClick(data) {
      console.log(data);
      if (data.id != 0) {
        this.form.agencyId = data.id;
        this.level = data.level;
      }
      this.getTableFun();
    },
    onSeachFun() {
      this.pagination.current = 1;
      this.getTableFun();
    },
    handleDelete(val) {
      let _this = this;
      this.$alert(this.$t('是否确认删除该机构') + '？', {
        confirmButtonText: _this.$t('确定')
      }).then(() => {
        delAgency({
          agencyId: val.id
        }).then(res => {
          _this.$message.success(_this.$t('删除成功') + '!');
          _this.getTableFun();
          _this.getTreeFun();
        });
      });
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getTableFun();
    },
    checkedFun(val) {
      if (!this.isAuth('home.agencyStatus')) {
        this.$message.error(this.$t('暂无权限'));
        return false;
      }
      agencyStatus({
        agencyId: val.agencyId,
        status: val.status == 1 ? 0 : 1
      }).then(res => {
        this.$message.success(this.$t('修改成功') + '!');
        val.status = val.status == 1 ? 0 : 1;
      });
    }
  }
};